import { createRouter, createWebHashHistory, createMemoryHistory } from 'vue-router';
import useStore from '@/store';

const router = createRouter({
  history: createMemoryHistory(),

  routes: [
    {
      name: 'auth',
      path: '/auth',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter(to) {
        window.location.href = generateAbsoluteLink('auth');
      }
    },
    {
      name: 'landing',
      path: '/landing/:doClear?',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter(to) {
        window.location.href = generateAbsoluteLink('login', to.params.doClear === 'true');
      }
    },
    {
      name: 'home',
      path: '/home',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter: () => {
        window.location.href = generateAbsoluteLink('home');
      }
    },
    {
      name: 'catalog',
      path: '/catalog/:tag?',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter() {
        window.location.href = generateAbsoluteLink('catalog');
      }
    },
    {
      name: 'learning-program',
      path: '/learning-program',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter(to) {
        window.location.href = generateAbsoluteLink('learning-program');
      }
    },
    {
      name: 'leaderboard',
      path: '/leaderboard',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter() {
        window.location.href = generateAbsoluteLink('leaderboard');
      }
    },
    {
      name: 'resources',
      path: '/resources',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter() {
        window.location.href = generateAbsoluteLink('resources');
      }
    },
    {
      name: 'livestreams',
      path: '/livestreams',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter() {
        window.location.href = generateAbsoluteLink('live-stream');
      }
    },
    {
      name: 'promotions',
      path: '/promotions',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter() {
        window.location.href = generateAbsoluteLink('promotions');
      }
    },
    {
      name: 'messages',
      path: '/messages',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter() {
        window.location.href = generateAbsoluteLink('messages');
      }
    },
    {
      name: 'search',
      path: '/search',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter() {
        window.location.href = generateAbsoluteLink('search');
      }
    },
    {
      name: 'registration',
      path: '/registration',
      component: () => import('@/pages/EmptyPage.vue'),
      beforeEnter() {
        window.location.href = generateAbsoluteLink('registration');
      }
    },
    {
      name: 'login',
      path: '/login',
      beforeEnter: () => {
        const store = useStore();
        if (!store.isAuthenticated) {
          store.authService.login();
        } else {
          window.location.href = generateAbsoluteLink('home');
        }
      },
      component: () => import('@/pages/EmptyPage.vue')
    },
    {
      name: 'logout',
      path: '/logout',
      redirect: () => {
        const store = useStore();
        if (store.isAuthenticated) {
          store.authService.logout();
        }

        return { name: 'landing' };
      }
    }
  ]
});

export function generateAbsoluteLink(newSegment: string, clearSearchParams: boolean = false): string {
  const urlObj = new URL(window.location.href);
  const store = useStore();

  if (store.config.config.NV_APP_ROOT_URL) {
    urlObj.href = store.config.config.NV_APP_ROOT_URL;

    if (!urlObj.pathname.endsWith('/')) {
      urlObj.pathname += '/';
    }

    urlObj.pathname += newSegment;

    if (window.location.pathname.includes('.html')) {
      urlObj.pathname += '.html';
    }
  } else {
    if (urlObj.pathname.includes('.html')) {
      urlObj.pathname = urlObj.pathname.replace(/\/[^\/?]*\.html(?=\?|$)/, `/${newSegment}.html`);
    } else {
      urlObj.pathname = urlObj.pathname.replace(/\/[^\/]+\/?$/, `/${newSegment}`);
    }
  }

  if (clearSearchParams) {
    urlObj.search = '';
  }
  return urlObj.toString();
}

// router.beforeEach((to, from, next) => {
//
// });

export default router;
